import { render, staticRenderFns } from "./QuestionAddContent.vue?vue&type=template&id=1e951a95"
import script from "./QuestionAddContent.vue?vue&type=script&lang=js"
export * from "./QuestionAddContent.vue?vue&type=script&lang=js"
import style0 from "./QuestionAddContent.vue?vue&type=style&index=0&id=1e951a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports